var exports = {
  "s": "x93eb46d8--4c3f9a--price-container",
};

module.exports = exports;
